import { render, staticRenderFns } from "./OrdersDashboard.vue?vue&type=template&id=014be672&scoped=true"
import script from "./OrdersDashboard.vue?vue&type=script&lang=js"
export * from "./OrdersDashboard.vue?vue&type=script&lang=js"
import style0 from "./OrdersDashboard.vue?vue&type=style&index=0&id=014be672&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014be672",
  null
  
)

export default component.exports